import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './categories.routes';
import uuidv4 from 'uuid/v4';

export class CategoriesController {
  users = [];
  newThing = '';

  /*@ngInject*/
  constructor($http, $scope, $rootScope, $location, $stateParams, $filter, appConfig, toastr, Upload, Traduction) {
    var vm = this;
    vm.orderBy = "rank";
    vm.reverseSort = false;
    vm.data = {};

    $http.get(`/api/categories/${$stateParams.id}`).then(response => {
      $http.get('/api/users/get/contacts').then(users => {
        vm.categorie = response.data;
        updateLangue()
        refreshIdentifiants()
        vm.contacts = users.data;
        _.map(vm.categorie.Poste.Site.Users, function(user) {
          if (!_.map(vm.contacts, 'email').includes(user.email)) vm.contacts.push(user)
        })
        $rootScope.posteId = vm.categorie.posteId
        $rootScope.siteId = vm.categorie.Poste.siteId
        console.log(vm.categorie)
        vm.categorie.years = Math.floor(vm.categorie.expiryDate / 365)
        vm.categorie.mounths = Math.floor(vm.categorie.expiryDate / 30) - (Math.floor(vm.categorie.years * 12))
        vm.categorie.standbyTimer = vm.categorie.standbyTimer / 1000
        vm.categorie.autoEndTimer = (vm.categorie.autoEndTimer / 1000) / 60 / 60
        console.log(vm.categorie)
        _.isArray(vm.categorie.contacts) ? vm.data.impose = false : vm.data.impose = true;
        vm.listeIdentifiants = _.filter(vm.categorie.Poste.listeIdentifiants, { 'commun': true })
        vm.categorie.availableIdentifiants = _.filter(vm.categorie.Poste.listeIdentifiants, { 'commun': false })
        setTimeout(function() {
          $('.selectpicker').selectpicker('refresh');
        }, 10);
      });
    });


    $scope.$watch('vm.categorie.langues', function(newV, oldV) {
      if (oldV != newV) {
        if (oldV && oldV.length > newV.length) {
          var langueToRemove = _.difference(oldV, newV)[0];
          vm.categorie.traductions = _.filter(vm.categorie.traductions, function(trad) {
            if (trad.id != langueToRemove) return trad
          })
        }
        if (vm.categorie) {
          if (vm.categorie.langues) {
            var langues = _.filter(vm.availableLanguages, function(langue) { return (vm.categorie.langues.includes(langue.id)) })
            _.map(langues, function(langue) {
              if (!_.map(vm.categorie.traductions, 'id').includes(langue.id)) vm.categorie.traductions.push({ id: langue.id, name: langue.name, categoryName: '', message: '' })
            })
          }
        }
      }
    })

    vm.createFormation = function() {
      vm.data = {}
      vm.data.categorieId = vm.categorie._id
      $('#addFormation').modal("show")
    }

    vm.addFormation = function(paramForm) {
      if (vm.categorie.Formations.length == 0) vm.data.active = true
      vm.data.rank = vm.categorie.Formations.length;
      vm.data.goodAnwserCount = 0
      vm.data.supports = []
      vm.data.questions = []
      $http.post(`/api/formations`, vm.data).then(function(response) {
        $http.get(`/api/categories/${vm.categorie._id}`).then(function(resp) {
          vm.categorie = resp.data
          $('#addFormation').modal("hide")
          vm.categorie.standbyTimer = vm.categorie.standbyTimer / 1000
          vm.categorie.autoEndTimer = (vm.categorie.autoEndTimer / 1000) / 60
          vm.categorie.years = Math.floor(vm.categorie.expiryDate / 365)
          vm.categorie.mounths = Math.floor(vm.categorie.expiryDate / 30) - (Math.floor(vm.categorie.years * 12))
        })
      })
    }

    vm.editFormation = function(formation) {
      $location.path(`/formation/${formation._id}`)
    }

    vm.copyFormation = function(formation) {
      vm.data = {}
      vm.formationToCopy = angular.copy(formation)
      vm.formationToCopy.rank = vm.categorie.Formations.length;
      $('#copyFormation').modal('show')
    }

    vm.validateCopyFormation = function() {
      vm.formationToCopy.formationTemplate = vm.formationToCopy._id
      vm.formationToCopy._id = undefined
      vm.formationToCopy.active = false
      vm.formationToCopy.name = vm.data.name
      vm.formationToCopy.categorieId = vm.categorie._id
      $http.post('/api/formations?copy=true', vm.formationToCopy).then(function() {
        $('#copyFormation').modal('hide')
        location.reload();
      })
    }

    vm.deleteFormation = function(formation) {
      vm.formationToDelete = formation
      $('#deleteFormation').modal('show')
    }

    vm.validateDeleteFormation = function() {
      $scope.clicked = true
      $http.delete(`/api/formations/${vm.formationToDelete._id}`).then(response => {
        vm.categorie.Formations.splice(vm.categorie.Formations.indexOf(vm.formationToDelete), 1);
        $('#deleteFormation').modal('hide')
        $scope.clicked = false
        vm.data = {}
      }).catch(err => {
        console.log(err)
        vm.errors = { errorTitle: Traduction.selectedLanguage.dictionnary["error"], errorMessage: err.data.message }
        $scope.clicked = false
      });
    }

    vm.updateFormation = function(formation) {
      if (formation.active) var active = true
      else var active = false

      $http.patch(`/api/formations/${formation._id}`, { active: active }).then(function(response) {
        toastr.success($filter('translate')('trainingActivated'), $filter('translate')('terminalUpdated'));
      })
    }

    vm.save = function(categorieForm) {
      vm.data = angular.copy(vm.categorie)
      vm.data.expiryDate = (vm.data.years * 365) + (vm.data.mounths * 30)
      vm.data.standbyTimer = vm.data.standbyTimer * 1000
      vm.data.autoEndTimer = ((vm.data.autoEndTimer * 1000) * 60) * 60
      vm.data.identifiants = _.union(_.map(vm.listeIdentifiants, 'id'), vm.categorie.identifiants)
      vm.listeIdentifiants = _.filter(vm.categorie.Poste.listeIdentifiants, { 'commun': true })
      vm.categorie.availableIdentifiants = _.filter(vm.categorie.Poste.listeIdentifiants, { 'commun': false })
      uploadMass().then(function(response) {
        toastr.success($filter('translate')('saved'), $filter('translate')('terminalUpdated'));
      })
    }

    function uploadMass() {
      return new Promise(function(resolve, reject) {
        if (vm.data.image) {
          Upload.upload({
            url: `/api/categories/${vm.categorie._id}`,
            method: 'PUT',
            data: { file: vm.data.image, data: _.omit(vm.data, ['image']) }
          }).then(function(resp) {
            return resolve()
          }, function(resp) {
            return reject()
            $scope.clicked = false
            console.log('Error status: ' + resp.status);
          }, function(evt) {
            var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
            vm.uploadPercent = parseInt(90.0 * evt.loaded / evt.total);
          });
        } else {
          $http.patch(`/api/categories/${vm.data._id}`, vm.data).then(function() {
            return resolve()
          })
        }
      })
    };

    $scope.$watch('vm.categorie.contacts', function() {
      setTimeout(function() {
        $('.selectpicker').selectpicker('refresh');
      }, 10);
    })


    vm.errorFile = function(file){
      console.log(file)
      if(!['image/png'].includes(file.type)) {
        $('#errorFile').modal('show')
        $scope.$apply();
      } else {
        vm.categorie.image = file
      }
    }

    $('#listFormation').nestable({ group: 0 })
    $('#listFormation').on('change', function() {
      update_out('#listFormation', 'formation');
    });

    function update_out(selector, objet) {
      vm.loading = true;
      var out = $(selector).nestable('serialize');
      vm.sortedList = []
      _.forEach(out, function(ligne, index) {
        if (ligne.id && ligne.id != '') {
          vm.sortedList.push(_.assignIn(_.find(vm.categorie.Formations, { _id: ligne.id }), { rank: index }));
          $http.patch(`/api/formations/${ligne.id}`, { rank: index }).then(response => {
            vm.loading = false;
          })
        }
      })
    }

    function refreshIdentifiants() {
      vm.listeIdentifiants = _.filter(vm.categorie.Poste.listeIdentifiants, { 'commun': true })
      vm.availableIdentifiants = _.filter(vm.categorie.Poste.listeIdentifiants, { 'commun': false })
    }

    function updateLangue() {
      vm.availableLanguages = []
      _.forEach(vm.categorie.Poste.langues, function(languePoste) {
        vm.availableLanguages.push(_.find(vm.categorie.Poste.Site.langues, ['id', languePoste]))
      })
    }
  }
}

export default angular.module('aperamApp.categories', [uiRouter])
  .config(routing)
  .component('categories', {
    template: require('./categories.html'),
    controller: CategoriesController,
    controllerAs: 'vm'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/categories/categories.component.js